import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table';
import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import SearchBox from 'components/common/SearchBox';
import { useMedicos } from 'hooks/useMedicos';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useDebounce from 'hooks/useDebounce';
import MedicoTable, { medicoTableColumns } from 'components/tables/MedicoTable';

const Medicos = () => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    const { data, isLoading, error } = useMedicos(
        page,
        pageSize,
        debouncedSearchTerm
    );

    const table = useReactTable({
        data: data ?? [],
        columns: medicoTableColumns,
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel()
    });

    const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    if (isLoading)
        return (
            <Spinner animation="border" role="status" className="d-block mx-auto">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );

    if (error) {
        return <div>Erro ao carregar os médicos.</div>;
    }

    return (
        <div>
            <PageBreadcrumb
                items={[
                    { label: 'Retaguarda', url: '/retaguarda' },
                    { label: 'Médicos', url: '/retaguarda/medicos' }
                ]}
            />
            <div className="mb-9">
                <h2 className="mb-5">Médicos</h2>

                <AdvanceTableProvider {...table}>
                    <div className="mb-4">
                        <div className="d-flex flex-wrap gap-3">
                            <SearchBox
                                placeholder="Pesquisar médico"
                                onChange={handleSearchInputChange}
                            />
                            <div className="ms-xxl-auto">
                                <Button
                                    variant="primary"
                                    as={Link}
                                    to="/cadastros/medicos/novo"
                                >
                                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                                    Cadastrar
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
                        <MedicoTable />
                    </div>
                </AdvanceTableProvider>
            </div>
        </div>
    );
};

export default Medicos; 